module.exports = __webpack_public_path__ + "static/media/centerMatBlue35.b82cad0c.png";